<template>
  <div
    class="component-d3661978"
    resmed-component-name="share"
    v-bind:style="{ 'background-color': acf.layout['background-color'] }"
  >
    <div class="component">
      <div class="row justify-content-center">
        <div class="col-md-8 text-center">
          <h5>Share this page</h5>
          <div class="addthis">
            <div class="addthis_inline_share_toolbox_p5c8"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "component-d3661978", // share
  props: ["acf"],
  created() {
    $.getScript(
      "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5bd7a1ce3bb17879",
      (data, textStatus, jqxhr) => {
        // -->
      }
    );
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d3661978 {
  padding: 3rem 0;
  overflow: hidden;
}

.component {
  // -->
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d3661978 {
  .at-resp-share-element {
    .at-share-btn {
      padding: 1rem;
      margin: 0 0.625rem;
      box-shadow: 0 0.325rem 12px 2px rgba(0, 0, 0, 0.1666667);
      background-color: $cc-resmed-white !important;

      svg {
        fill: $cc-resmed-action-red !important;
      }
    }
  }
}
</style>